var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.16667V9.63333C7 10.7534 7 11.3135 7.21799 11.7413C7.40973 12.1176 7.71569 12.4236 8.09202 12.6153C8.51984 12.8333 9.0799 12.8333 10.2 12.8333H10.3333M10.3333 12.8333C10.3333 13.5697 10.9303 14.1667 11.6667 14.1667C12.403 14.1667 13 13.5697 13 12.8333C13 12.097 12.403 11.5 11.6667 11.5C10.9303 11.5 10.3333 12.097 10.3333 12.8333ZM3.66667 2.16667L10.3333 2.16666M3.66667 2.16667C3.66667 2.90305 3.06971 3.5 2.33333 3.5C1.59695 3.5 1 2.90305 1 2.16667C1 1.43029 1.59695 0.833332 2.33333 0.833332C3.06971 0.833332 3.66667 1.43029 3.66667 2.16667ZM10.3333 2.16666C10.3333 2.90304 10.9303 3.5 11.6667 3.5C12.403 3.5 13 2.90305 13 2.16667C13 1.43029 12.403 0.833332 11.6667 0.833332C10.9303 0.833332 10.3333 1.43029 10.3333 2.16666ZM7 7.5H10.3333M10.3333 7.5C10.3333 8.23638 10.9303 8.83333 11.6667 8.83333C12.403 8.83333 13 8.23638 13 7.5C13 6.76362 12.403 6.16667 11.6667 6.16667C10.9303 6.16667 10.3333 6.76362 10.3333 7.5Z",
    stroke: "#537089",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.f55c47c5fb233360322a8bb9e738e45c.svg";
export { ForwardRef as ReactComponent };